export const CREATE_TRAVEL_REQUEST = "CREATE_TRAVEL_REQUEST";
export const FETCH_TRAVEL_REQUESTS = "FETCH_TRAVEL_REQUESTS";
export const FETCH_TRAVEL_REQUEST = "FETCH_TRAVEL_REQUEST";
export const EDIT_TRAVEL_REQUEST = "EDIT_TRAVEL_REQUEST";
export const DELETE_TRAVEL_REQUEST = "DELETE_TRAVEL_REQUEST";
